import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, CustomPageConfigService, Customer, CustomerService, HomeComponent, HomeNavigationConfigService } from 'gung-standard';
import { forkJoin, Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs';

@Component({
    selector: 'tylo-tylo-home',
    templateUrl: './tylo-home.component.html',
    styleUrls: ['./tylo-home.component.css'],
    standalone: false
})
export class TyloHomeComponent extends HomeComponent implements OnInit {
  protected override router = inject(Router);
  protected override authService = inject(AuthService);
  protected override customerService = inject(CustomerService);
  protected override homeNavigationConfigService = inject(HomeNavigationConfigService);
  protected override customPageConfigService = inject(CustomPageConfigService);

  ngOnInit(): void {
    this.authService
      .getCurrentUser()
      .pipe(
        first(),
        mergeMap(user => {
          const requests: Observable<any>[] = [of(user)];
          // get customers only for users
          if (!(user.roles.includes('SALES') || user.roles.includes('ADMIN')) && user.roles.includes('USER')) {
            requests.push(this.customerService.getCustomers().pipe(first()));
          }
          return forkJoin(requests);
        })
      )
      .subscribe(([user, customers]) => {
        if (user.roles.includes('DIGITALASSETS')) {
          this.router.navigate(['/digital-assets']);
        } else if (user.roles.includes('SALES') || user.roles.includes('ADMIN')) {
          this.router.navigate(['/sales-dashboard']);
        } else if (user.roles.includes('USER')) {
          if (customers && (customers as Customer[]).length > 1) {
            this.router.navigate(['/delivery-location']);
          } else {
            this.router.navigate(['/categories']);
          }
        } else if (user.roles.includes('ANONYMOUS')) {
          this.router.navigate(['/products']);
        }
      });
  }
}
